import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ListenableSubscribable } from '@benzinga/subscribable';

import { PlusProduct, TradeAlertProductData, TradeAlertVideos } from './entities';
import { PlusRestful } from './restful';
import { ingestProducts } from './ingest';
import { Session } from '@benzinga/session';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'plus:get_plus_products_error';
  type: 'error';
}

interface RetrievingPlusProductsEvent {
  type: 'plus:retrieving_plus_products';
}

export type PlusRequestEvent = ErrorEvent | RetrievingPlusProductsEvent;

export class PlusRequest extends ListenableSubscribable<PlusRequestEvent> {
  private restful: PlusRestful;

  constructor(session: Session) {
    super();
    this.restful = new PlusRestful(session);
  }

  public getProducts = async (): SafePromise<PlusProduct[]> => {
    this.dispatch({
      type: 'plus:retrieving_plus_products',
    });
    const products = await ingestProducts(this.restful.getProducts());
    if (products.err) {
      this.dispatch({
        error: products.err,
        errorType: 'plus:get_plus_products_error',
        type: 'error',
      });
    }
    return products;
  };

  public getProductData = async (product: string): SafePromise<TradeAlertProductData> => {
    return this.restful.getProductData(product);
  };

  public getProductVideos = async (product: string): SafePromise<TradeAlertVideos> => {
    return this.restful.getProductVideos(product);
  };
}
